import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import { useContext } from "react"
import SiteContext from "../../contexts/SiteContext"

import IconButton from "@material-ui/core/IconButton"
export default function DialogAcao(props) {
    const { aplicativoDados } = useContext(SiteContext)

    const { dialogAcao, handleClose } = props

    const { open, titulo, alerta, descricao, secundario, primario } = dialogAcao

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img src={aplicativoDados.urlLogo} className="imgModal" />

                <DialogTitle id="tituloDialogAcao">
                    <IconButton className="setaVoltarModal" onClick={handleClose}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                    {titulo}
                </DialogTitle>

                <DialogContent>
                    {alerta}
                    <DialogContentText id="alert-dialog-description">{descricao}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            secundario.acao()
                            handleClose()
                        }}
                        style={{ color: "#dc3545" }}
                    >
                        {secundario.texto}
                    </Button>
                    <Button
                        onClick={() => {
                            primario.acao()
                            handleClose()
                        }}
                        style={{ background: "#28a745", color: "white" }}
                    >
                        {primario.texto}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
